import React from "react";
import { connect } from "react-redux";
import { goTo } from "../tools";

import gnpRegistro from "../gnp-registro/gnp-registro.css";
import Seguridad from "./seguridad.cmpt";
import ContratoMedios from "./contrato-medios.cmpt";
import ContratoDatos from "./contrato-datos.cmpt";
import LoSentimos from "./lo-sentimos.cmpt";
import Bienvenido from "./bienvenido.cmpt";
import { movil } from '../app-movil';

const mapState = (state) => {
	return {
		loading: state.global.loading,
		paso: state.contrato.paso,
		dispositivo: state.global.dispositivo,
	};
};

const mapDispatch = (dispatch) => {
	return {
		alerta: (sTitulo, sMensaje, fnCerrar) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnCerrar });
		},
		altaHash: (hashOne, hashTwo, hashThree) => {
			dispatch({ "type": "REGISTRO_HASH", "hashOne": hashOne, "hashTwo": hashTwo, "hashThree": hashThree });
		},
		setPaso: (paso) => {
			dispatch({ "type": "CONTRATOS_PASO", "paso": paso });
		}
	};
};

class Flujo extends React.Component {

	componentWillMount = () => {
		this.props.setPaso(1);

		console.log("this.props.hashOne", this.props.hashOne);
		console.log("this.props.hashTwo ", this.props.hashTwo);
		console.log("this.props.hashThree", this.props.hashThree);

		if (this.props.hashOne && this.props.hashOne != "" && this.props.hashTwo && this.props.hashTwo != "") {
			this.props.altaHash(this.props.hashOne, this.props.hashTwo, this.props.hashThree);
		} else {
			this.props.alerta("ERROR", "La liga no puede ser procesada", () => {
				if (this.props.dispositivo === 'app') {
					let mensaje = { "return": "home" };
					movil("", mensaje);
				} else
					goTo("login");
			});
		}
	}

	componentDidMount = () => {
		const url = window.location.hash;
		var main = document.getElementsByClassName("main")[0];
		if (url.includes("#!/gnp/registro-seguridad")) {
			main.style.width = "1250px";
		}
	}

	render() {
		return (
			<div className="gnpRegistro">
				{this.props.paso === 1 &&
					<Seguridad />
				}
				{this.props.paso === 2 &&
					<ContratoMedios />
				}
				{this.props.paso === 3 &&
					<ContratoDatos />
				}
				{this.props.paso === 4 &&
					<LoSentimos />
				}
				{this.props.paso === 5 &&
					<Bienvenido />
				}
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Flujo);


// WEBPACK FOOTER //
// ./src/gnp-registro-seguridad/flujo.cmpt.js